import { format } from "date-fns";
import { months, reminders } from "./dummy";
// export { domUtils, trapFocus, isControlKey } from "@/plugins/dom";
export { mockAxiosError, textSpacer, optimizeFileStackURL, splitArrayIntoSets } from "@/plugins/formatters";
// export { daysFromNow } from "@/plugins/dates";
// export { wait, poller } from "@/plugins/timers";
export { isAdmin, allowAccess } from "@/plugins/roles"; ;

export function simpleUniqueID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
};

export function objectIsEmpty(obj) {
    return (Object.keys(obj).length === 0 && obj.constructor === Object);
}

export function generateReference(prefix = "", suffix = "") {
    const length = 12;
    const timestamp = new Date().getTime();

    function _getRandInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function generate() {
        const ts = timestamp.toString();
        const parts = ts.split("").reverse();
        let ref = "";

        for (let i = 0; i < length; ++i) {
            const index = _getRandInt(0, parts.length - 1);
            ref += parts[index];
        }

        return ref;
    }

    return prefix + generate() + suffix;
}

/**
 * @param {string} filename
 * @param {string} content - Raw content.
 * @param {"text"| "image"} filetype
 */
export function downloadFromString(filename, content, filetype) {
    const element = document.createElement("a");

    if (filetype === "image") {
        element.setAttribute("href", "data:image/png;base64," + encodeURIComponent(content));
    } else {
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(content));
    }

    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

export function generateSlug() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 12; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

export function pushOrReplace(arr = [], value, predicateFn) {
    const foundIndex = arr.findIndex(predicateFn);
    if (foundIndex <= -1) {
        arr.push(value);
    } else {
        arr[foundIndex] = value;
    }
    return arr;
}

export function redirectWithReload(path = "") {
    if (path.startsWith("/") === false) {
        path = "/" + path;
    }
    if (process.browser) {
        window.location.href = window.location.origin + path;
    }
}

export function matchUrl(pattern = "", url = "") {
    pattern = pattern.startsWith("/") ? pattern : "/" + pattern;
    url = url.startsWith("/") ? url : "/" + url;

    const patternUrl = pattern.split("?")[0] || "";
    const patternParams = pattern.split("?")[1] || "";
    const urlUrl = url.split("?")[0] || "";
    const urlParams = url.split("?")[1] || "";

    const compareUrls = (urlOne = "", urlTwo = "") => {
        const urlOneParts = urlOne.split("/");
        const urlTwoParts = urlTwo.split("/");
        if (urlOneParts.length !== urlTwoParts.length) {
            return false;
        }

        for (let i = 0; i < urlOneParts.length; i++) {
            if (urlOneParts[i].startsWith(":") || urlTwoParts[i].startsWith(":")) {
                continue;
            }
            if (urlOneParts[i] !== urlTwoParts[i]) {
                return false;
            }
        }

        return true;
    };

    const compareParams = (paramsOne = "", paramsTwo = "") => {
        const paramsOneParts = paramsOne.split("&");
        const paramsTwoParts = paramsTwo.split("&");
        if (paramsOneParts.length !== paramsTwoParts.length) {
            return false;
        }

        for (let i = 0; i < paramsOneParts.length; i++) {
            const queryOne = (paramsOneParts[i] || "").split("=")[0] || "";
            const queryTwo = (paramsTwoParts[i] || "").split("=")[0] || "";

            if (queryOne !== queryTwo) {
                return false;
            }
        }

        return true;
    };

    if (!patternParams) {
        return compareUrls(patternUrl, urlUrl);
    } else {
        return compareUrls(patternUrl, urlUrl) && compareParams(patternParams, urlParams);
    }
}

export function goBackToLastUniqueRoute(query) {
    if (process.browser === false) {
        return;
    }

    const lastRoute = getLastUniqueRoute();
    if (lastRoute) {
        window.$nuxt.$router.push({ path: lastRoute.fullPath, query });
        return;
    }

    window.$nuxt.$router.go(-1);
}

export function getLastUniqueRoute() {
    if (process.browser === false) {
        return;
    }

    const currentPath = window.location.pathname;
    const previousRoutes = JSON.parse(window.localStorage.previousRoutes || "[]");

    for (let i = previousRoutes.length - 1; i >= 0; i--) {
        const previousRoute = previousRoutes[i] || {};
        if ((previousRoute.path.includes(currentPath) === false) && previousRoute.fullPath) {
            return previousRoute;
        }
    }
}

export function waitTill({ predicate = () => true, counts = 10, interval = 400 }) {
    let intervalId;
    let count = 0;
    return new Promise((resolve, reject) => {
        try {
            const val = predicate();
            if (val) {
                resolve(val);
            }

            intervalId = setInterval(() => {
                count = count + 1;
                const val = predicate();
                if (val) {
                    resolve(val);
                    clearInterval(intervalId);
                } else if (count > counts) {
                    reject(mockAxiosError({ message: "Waiting timeout error. Action took too long" }));
                    clearInterval(intervalId);
                }
            }, interval);
        } catch (err) {
            reject(err);
        }
    });
}

export function genCorridorString({ fromCountryIso, fromCurrencyCode, toCountryIso, toCurrencyCode }) {
    return fromCountryIso + "_" + fromCurrencyCode + ":" + toCountryIso + "_" + toCurrencyCode;
};

export function splitFullName(name = "") {
    const names = String(name).split(" ");
    if (names.length === 1) {
        return [names[0], ""];
    }
    const firstName = names.slice(0, names.length - 1).join(" ");
    const lastName = names[names.length - 1];
    return [firstName, lastName];
}

export const nth = (value) => {
    if (value > 3 && value < 21) {
        return "th";
    }
    switch (value % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
    }
};

export function toFixedDown(val, digits) {
    const re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)");
    const m = val.toString().match(re);
    return m ? parseFloat(m[1]) : parseFloat(String(val.valueOf()));
}

export function removeNan(val) {
    if (isNaN(val)) {
        return 0;
    }
    return val;
}

export function stripDecimals(n) {
    return removeNan(n) || 0;
}

export const stripNegative = (val) => {
    return Math.abs(val);
};

export function toFixedRound(val, digits) {
    const re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)");
    const m = val.toString().match(re);
    return m ? stripDecimals(m[1]) : stripDecimals(String(val.valueOf()));
}

export function formatCount(x) {
    return (x) ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : x;
};

export function convertObjectToQueryString( obj ) {
    // return Object.keys( obj ).map(key => key + '=' + obj[key]).join('&');
    var str = [];
    for (var p in obj) {
      
        if( obj[p] === undefined ) { 
            continue;
        }
      
        if (obj.hasOwnProperty(p)) {
            str.push((p) + "=" + (obj[p]));
        }
    }
    
    return str.join("&");
}

export function transformQueryToString( url = "", queryParams = undefined ) {
    let queryString = url;
    if (queryParams) queryString += "?" + convertObjectToQueryString( queryParams );
    
    return queryString;
}
  
export function transformObjectToQueryString( obj ) {
    var str = [];
    for (var p in obj) {
      
        if( obj[p] === undefined ) { 
            continue;
        }
      
        if (obj.hasOwnProperty(p)) {
            str.push((p) + "=" + (obj[p]));
        }
    }
    
    return str.join("&");
}

/**
 * @param  {Date} date: Mon Feb 27 2017 18:33:38 GMT+0000 (UTC)
 * @returns {string} 27/02/2017
 */
export function formatDateTime(date) {
    return format(new Date(date), "dd/MM/yyyy");
}

/**
 * @param  {string} dateString: 2022-08-26T13:31:34.062Z
 * @returns {string} Fri 12 July 2024 3:02 PM
 */
export function formatDateStrings(dateString) { 
    if (!dateString) return "";
    
    const date = new Date(dateString);
    const pattern = "E dd MMMM yyyy h:mm a";

    return format(new Date(date), pattern);
}

/**
 * @param  {object} queryObj example: serialize({
  foo: "hi there",
  bar: {
    blah: 123,
    quux: [1, 2, 3]
  }
}
 * @returns {string} example: foo=hi%20there&bar=100%25
 */

export function serilaizeQuery(queryObj) {
    let str = [];
    for (let p in queryObj)
        if (queryObj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(queryObj[p]));
        }
    return str.join("&");
}

/**
 * @param  {object} routeData
 * @param  {object} pageData 
}
 * @returns {{
        page: number,
        email: string,
        name: string,
    }}
 */
export function assembleQueryList(pageData) {
    const queryObj = {};

    if (pageData?.page) {
        if (typeof pageData.page === "number") {
            queryObj.page = pageData.page;
        }

        if (typeof pageData.page === "string") {
            queryObj.page = parseInt(pageData.page);
        }
    } 

    const pageDataEntries = Object.entries(pageData);

    for (let [key, prop] of pageDataEntries) {
        if (key && (prop || prop?.length)) {
            queryObj[key] = prop;
        }
    }

    return queryObj;
}

export function sortList(sortingType, arr, valueToSortBy) {
    arr.sort((a, b) => {
        var lowerValue = a[valueToSortBy].toLowerCase(); // ignore upper and lowercase
        var higherValue = b[valueToSortBy].toLowerCase();

        if (lowerValue < higherValue) {
            return sortingType === "Ascending" ? -1 : 1;
        } else if (lowerValue > higherValue) {
            return sortingType === "Ascending" ? 1 : -1;
        } 
    }); 
}

export function formatPhoneNumber(str) {
    if (str && typeof str === "string") {
        return str.slice(1, str.length);
    } else {
        return "";
    }
}

export function toLowerCaseTransform(str) {
    return str && typeof str === "string" ? str.toLowerCase() : "";
}

export function getMonth(date, isConverted) {
    let d;

    if (date && !isConverted) {
        d = new Date(date);
    } else if (date && isConverted) {
        d = date;
    } else {
        d = new Date();
    }

    return months[d.getMonth()];
}

export function getMonthFromNum(num, subtract = true) {
    if (!num || typeof num !== "number") return "";

    const index = subtract ? num - 1 : num;

    return months[index];
}

export function setItemOnLS(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
};

export function getItemOnLS(key) {
    localStorage.getItem(key);
};

export function clearDataOnLs(key) {
    window.localStorage.removeItem(key);
}

export function setItemOnSS(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
};

export const getStoredTime = (key) => parseInt(sessionStorage.getItem(key) || "0", 10);

export function isTimeExpired(key) {
    if (!key) return;

    
    const now = Date.now();
    const refreshExpiresAt = getStoredTime("z:projectsListExpiresAt");

    if (!refreshExpiresAt || refreshExpiresAt <= now) {
        return true;
    } else {
        return false;
    }
}

export function debounce(fn, ms = 1000) {
    clearTimeout(window.debounceId);
  
    window.debounceId = setTimeout(fn, ms);
}

export function validateEmail(value) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)?(gmail\.com|[a-zA-Z0-9-]+\.(com|eu|ng|uk|us))$/;
    return emailRegex.test(value);
}

export function validatePassword(val) {
    if (
        val.length > 8 || 
        /[A-Z]/.test(val) || 
        /[a-z]/.test(val) ||
        /\d/.test(val) || 
        /[!@#$%^&*(),.?":{}|<>]/.test(val)
    ) {
        return true;
    } else {
        return false;
    }
}

export function validateNameString(value) {
    if (!value) {
        return false;
    }

    const nameRegex = /^[a-zA-Z\s]*$/;

    if (!nameRegex.test(value)) {
        return false;
    } 
    
    if (value.length < 4) {
        return false;
    }
    
    return true;

}

export function convertStringAmountToInt(str) {
    if (!str) return 0;

    const val = str.split(",").join("");
    return Number(val);
}

export function constructRoutePathName(name) {
    if (!name || typeof name !== "string") return;

    const regexPattern = /\s\W*/;

    const split = name?.trim()?.split(regexPattern)?.join("-")?.toLowerCase();

    return split;
};

export function groupList(list = [], keyGetterFunc) {   
    if (!keyGetterFunc || !list) return;
    
    const map = new Map();

    list.forEach(item => {
        const key = keyGetterFunc(item);
        const collection = map.get(key);

        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

export function time_ago(date) {
    const formatDate = new Date(date).getTimezoneOffset() + 60 * 60 * 1000;
  
    var time = new Date(Date.now() - formatDate);
    //
    switch (typeof time) {
    case "number":
        break;
    case "string":
        time = +new Date(time);
        break;
    case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
    default:
        time = +new Date();
    }
    //
  
    var time_formats = [
        [60, "seconds", 1], // 60
        [120, "1 minute ago", "1 minute from now"], // 60*2
        [3600, "minutes", 60], // 60*60, 60
        [7200, "1 hour ago", "1 hour from now"], // 60*60*2
        [86400, "hours", 3600], // 60*60*24, 60*60
        [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
        [604800, "days", 86400], // 60*60*24*7, 60*60*24
        [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
        [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
        [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
        [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
        [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
  
    var seconds = (+new Date() - time) / 1000,
        token = "ago",
        list_choice = 1;
  
    if (seconds == 0) {
        return "Just now";
    }
    if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "from now";
        list_choice = 2;
    }
  
    var i = 0,
        format;
    while ((format = time_formats[i++]))
        if (seconds < format[0]) {
            if (typeof format[2] == "string") return format[list_choice];
            else
                return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
        }
  
    //
    return time;
}

export function generateInvoiceRefNumber() {
    const baseChar = "01234567";
    let generatedNum = "";
    const length = 6;

    for (let i = length; i > 0; --i) {
        generatedNum += baseChar[Math.floor(Math.random() * baseChar.length)];
    }

    return generatedNum;
}

export function buildMap(arr = []) {
    const map = {};
    
    for (const val of arr) {
        map[val.code] = val;
    }
    return map;
}

export function buildCustomRecurrence(options) {
    let rule = "RRULE:FREQ=" + options.frequency;
  
    if (options.interval > 1) {
        rule += ";INTERVAL=" + options.interval;
    }
  
    if (options.count) {
        rule += ";COUNT=" + options.count;
    }
  
    if (options.until) {
    // Format date as YYYYMMDD
        const until = options.until.toISOString().replace(/[-:]/g, "").split("T")[0];
        rule += ";UNTIL=" + until + "T000000Z";
    }
  
    if (options.byDay && options.byDay.length > 0) {
        rule += ";BYDAY=" + options.byDay.join(",");
    }
  
    return rule;
}

export function camelCaseToSpaced(str) {
    // Replace capital letters with a space followed by the lowercase version
    return str.replace(/([A-Z])/g, " $1").toLowerCase();
}

export function isFilterValueEmpty(value) {
    if (!value) return true;

    if (value && typeof value === "object") {
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        return Object.values(value).every(v => !v);
    }

    if (typeof value === "string") {
        return value === "";
    }
}

export function formatTimeToAmPm(isoTimeString) {
    const date = new Date(isoTimeString);
    
    return new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(date);
}

// Format time with AM/PM
function formatTime(date) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
                
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    const formattedMinutes = minutes === 0 ? "" : ":" + (minutes < 10 ? "0" + minutes : minutes);
                
    return `${hours}${formattedMinutes}${ampm}`;
}

export function formatDateRange(startDateStr, endDateStr) {
    if (!startDateStr) return "";
    
    // Parse ISO dates
    const startDate = new Date(startDateStr);
    const endDate = endDateStr ? new Date(endDateStr) : new Date();
            
    // Get day of week
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const dayOfWeek = weekdays[startDate.getDay()];
            
    // Get day of month
    const dayOfMonth = startDate.getDate();

    // Get year
    const year = startDate.getFullYear();
            
    // Get month
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[startDate.getMonth()];
                     
    // Format start and end times
    const startTime = formatTime(startDate);
    const endTime = formatTime(endDate);
            
    // Put it all together
    return `${dayOfWeek}, ${dayOfMonth} ${month} ${year} ⋅ ${startTime} – ${endTime}`;
}

export function splitExpiryDate(value) {
    // Try splitting with the standard forward slash
    let parts = value.split("/");

    // If the split didn't result in two parts, try splitting with the division slash
    if (parts.length !== 2) {
        parts = value.split("∕");
    }

    // If we still don't have two parts, or if either part is empty, return an empty array or handle as error
    if (parts.length !== 2 || parts.some(part => part.trim() === "")) {
        return []; // Or throw an error, or return a specific error value
    }

    // Parse the parts as integers
    return parts.map(numStr => parseInt(numStr.trim(), 10));
}

export function buildCardDetails(cardData, cardBin, currency) {
    const [expiry_month, expiry_year] = cardData.ccExpiry.split("∕");

    const authorization = {
        address: cardData.billingAddress || "",
        country: cardData.billingCountry || "",
        city: cardData.billingCity || "",
        state: cardData.billingState || "",
        zipcode: cardData.postalCode || "",
    };

    const { card_type, issuing_country } = cardBin;

    return {
        authorization,
        card_type,
        issuing_country: issuing_country || cardData.billingCountry,
        card_number: cardData.cardNumber.replaceAll(" ", ""),
        currency,
        cvv: cardData.cvv,
        expiry_month,
        expiry_year,
        fullname: cardData.cardName,
    };
}

export function convertNumStringToNum(stringAmount) {
    if (!stringAmount) return 0;

    const withoutComma = stringAmount.replace(/,/g, "");

    // 2. Convert the string to a floating-point number
    return parseFloat(withoutComma);

    // If you specifically need an integer (and are okay with losing the decimal part):
    // const integerAmount = parseInt(withoutComma);
    // console.log(integerAmount); // Output: 4999
    // console.log(typeof integerAmount); // Output: number
}

export function formatTimestampToTime(timestamp) {
    const date = new Date(timestamp);

    // Get hours in 24-hour format
    let hours = date.getUTCHours(); // Use getUTCHours() as the timestamp is in UTC ('Z' suffix)

    // Determine AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // The hour '0' should be '12 AM'

    // Return the formatted string
    return `${hours} ${ampm}`;
}

export function parseDateFromFilter(dateString) {
    const [day, month, year] = dateString.split("/").map(Number);
    return new Date(Date.UTC(year, month - 1, day));
}

export function extractCCEmails(emails = [] || "") {
    let ccEmails = [];

    if (Array.isArray(emails)) {
        ccEmails = emails;
    }  
    
    if (typeof emails === "string") {
        ccEmails = emails.split(",");
    }
    
    return ccEmails;
}

export function getDateFromEnum(val, dueDate) {
    let date = dueDate ? new Date(dueDate) : new Date();
    let dueDateNo = undefined;

    if (!val) return undefined;
    const days = Number(val?.split("_")[0] || 7);

    switch (val) {
    case "30_days_before":
    case "21_days_before":
    case "14_days_before":
    case "7_days_before":
    case "3_days_before":
    case "1_day_before":
    case "on_due_date":
    case "1_day_after":
    case "3_days_after":
    case "7_days_after":
    case "14_days_after":
    case "21_days_after":
    case "30_days_after":
    case "60_days_after":
        date.setDate(date.getDate() - days);
        dueDateNo = date.getTime();
        break;

    default:
        break;
    }
	
    return dueDateNo;
}

export function extractDateFilters(val, dueDate) {
    let date = dueDate ? new Date(dueDate) : new Date();

    if (!val) return undefined;
    
    const year = new Date().getFullYear();

    switch (val) {
    case "7_days":
        date.setDate(date.getDate() - 7);
        return { startDate: date, endDate: new Date() };

    case "30_days":
        date.setDate(date.getDate() - 30);
        return { startDate: date, endDate: new Date() };

    case "1_year":
        return { startDate: new Date(`${year}-01-01`), endDate: new Date(`${year + 1}-01-01`) };

    case "today":
        return { startDate: date, endDate: new Date() };

    default:
        return undefined;
    }
}

export function extractInvoiceDateFilters(val) {
    if (!val) return undefined;

    console.log({ val });

    let date = new Date();
    const day = Number(val?.split("_")[0] || 7);

    switch (val) {
    case "7_days":
    case "14_days":
    case "21_days":
    case "30_days":
    case "60_days":
    case "90_days":
        date.setDate(date.getDate() + day);
        break;

    default:
        return undefined;
    }

    return date;
}